import React, { useState } from 'react'
import { ageCalculate, checkNameShowHide, decimalToFeetInches, nameMask } from '../../utils/utils';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Cookies from "js-cookie";

function SearchProfileList({selfUserDetail, searchData, sendInterest, showPopUpButton, showInterest, planDetailUser, totalUserSentInterest, expiryDate, shortlistButton, requestPhoto, removeShortlistButton}) {
  const navigate = useNavigate();
  const [callNumbers, setCallNumbers] = useState({});
  const [loadingId, setLoadingId] = useState(null);

  const token = JSON.parse(decodeURIComponent(Cookies.get("authTokenUserLogin") || Cookies.get("authTokenUser") || null));
   const { userDetailLogin } = useSelector((state) => state.auth);

 // console.log('inner', planDetailUser, totalUserSentInterest, expiryDate)
 let blurPhoto = 0 
 if(!planDetailUser || Object.keys(planDetailUser).length === 0  || planDetailUser?.plan_id?.name === 'Basic' || (planDetailUser?.plan_id?.name === 'Gold' && totalUserSentInterest > parseInt(planDetailUser?.send_interest)) || (planDetailUser?.plan_id?.name === 'Premium' && totalUserSentInterest > parseInt(planDetailUser?.send_interest)) || (expiryDate && (planDetailUser?.plan_id?.name === 'Gold' || planDetailUser?.plan_id?.name === 'Premium'))){
    //console.log('blur photo')
    blurPhoto = 1
  }

 
    
  console.log('selfUserDetail', selfUserDetail);

    return (
    <>
     { searchData && searchData?.length > 0 ? (
                
                  searchData.map((searchList, index) => {

                    let profilePhoto;
                    let profilePhotoBlur;
                    let profilePhotoShow;
                    if(searchList.profile_photo === 1){
                      profilePhoto = searchList.photo
                      profilePhotoShow = searchList.photo
                      profilePhotoBlur = searchList.photo_blur
                      if(blurPhoto === 1){
                      profilePhoto = searchList.photo_blur  
                      }
                    } else if(searchList.profile_photo === 2){
                      profilePhoto = searchList.photo1
                      profilePhotoShow = searchList.photo1
                      profilePhotoBlur = searchList.photo1_blur
                      if(blurPhoto === 1){
                      profilePhoto = searchList.photo1_blur  
                      }
                    } else if(searchList.profile_photo === 3){
                      profilePhoto = searchList.photo2
                      profilePhotoShow = searchList.photo2
                      profilePhotoBlur = searchList.photo2_blur
                      if(blurPhoto === 1){
                      profilePhoto = searchList.photo2_blur  
                      }
                    } else if(searchList.profile_photo === 4){
                      profilePhoto = searchList.photo3
                      profilePhotoShow = searchList.photo3
                      profilePhotoBlur = searchList.photo3_blur
                      if(blurPhoto === 1){
                      profilePhoto = searchList.photo3_blur  
                      }
                    } else if(searchList.profile_photo === 5){
                      profilePhoto = searchList.photo4
                      profilePhotoShow = searchList.photo4
                      profilePhotoBlur = searchList.photo4_blur
                      if(blurPhoto === 1){
                      profilePhoto = searchList.photo4_blur  
                      }
                    } else {
                      profilePhoto = searchList.photo
                      profilePhotoShow = searchList.photo
                      profilePhotoBlur = searchList.photo_blur
                      if(blurPhoto === 1){
                      profilePhoto = searchList.photo_blur  
                      }
                    }

                    
                  const handleChatClick = (e, user) => {
                    e.preventDefault();

                    if (!user?._id) return;

                    if (!planDetailUser || planDetailUser?.plan_id === '6913323a5be8a54eb6b4ab7a') {
                      navigate('/membership-plan'); 
                      return;
                    }

                    if (user?.profileSettings?.chat_disabled) {
                      alert('Chat is disabled for this partner');
                      return;
                    }
                     if(!user?.profile_id){
                      alert('Profile is not completed yet');
                      return;
                     }

                      navigate(`/chat-box/${user._id}`);
                      
                  };

                  const handleCallNoView = async (e, user) => {
                        e.preventDefault();

                        if (!user?._id) return;

                        if (!planDetailUser || planDetailUser?.plan_id === "6913323a5be8a54eb6b4ab7a") {
                          navigate("/membership-plan");
                          return;
                        }

                        try {
                           setLoadingId(user._id);

                          const response = await fetch(
                            `${process.env.REACT_APP_BASE_URL_API}/api/user/contact-user`,
                            {
                              method: "POST",
                              headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                              },
                              body: JSON.stringify({
                                user_id: userDetailLogin?._id,
                                view_id: user._id,
                              }),
                            }
                          );

                          const data = await response.json();

                          if (response.ok && data?.status === true) {
                             setCallNumbers((prev) => ({
                                  ...prev,
                                  [user._id]: user.contact_no, // ✅ only this user
                                }));
                          } else {
                            alert(data?.message || "Unable to fetch number");
                          }
                        } catch (error) {
                          console.error(error);
                          alert("Server error");
                        } finally {
                           setLoadingId(null);
                        }
                      };




                  return (

                <div className="profilelist-box d-md-flex align-items-md-start justify-content-md-start mb-2">
                  
                  {searchList?.profileSettings?.photo_show === 2 || (searchList?.photo_request_check && searchList?.photo_request_status === 1) ?
                  (
                    <div className="profilelist-img">
                    <Link to="#" onClick={(e) =>showPopUpButton(e, `/profile-details/${searchList._id}`)}>

                    <img src={profilePhotoShow ? `${process.env.REACT_APP_BASE_URL_IMAGE}${profilePhotoShow}` : searchList.gender === 'Male' ? 'assets/img/no-image-male.jpg':'assets/img/no-image-female.jpg'} alt="" width={223} />
                    </Link>
                  </div>
                  )
                                   
                    :
                    searchList?.profileSettings?.photo_show === 1 || blurPhoto === 1 ?
                    (
                    <div className="profilelist-img position-relative">
                    <div className="lockedimage pb-3">
                      <img src="assets/img/locked-icon.png" alt='' />
                      
                      
                      {searchList?.profileSettings?.photo_show === 1 ?
                      <>
                      {searchList?.photo_request_check ? null:
                      <Link to="#" onClick={(e) => {
                         e.preventDefault();
                        requestPhoto(searchList._id, index)
                        }
                      }>Request a Photo</Link>
                      }
                      
                      
                      </>
                        :
                      <>
                      Visible to
                      <br />
                      Premium Members
                      <a href="/membership-plan">View Plans</a>
                      </>
                      }
                    </div>
                    <Link to="#" onClick={(e) =>showPopUpButton(e, `/profile-details/${searchList._id}`)}>
                    <img src={profilePhotoBlur ? `${process.env.REACT_APP_BASE_URL_IMAGE}${profilePhotoBlur}` : searchList.gender === 'Male' ? 'assets/img/no-image-male.jpg':'assets/img/no-image-female.jpg'} alt="" />
                    </Link>
                  </div>
                    
                    
                    )
                  :
                  (
                  <div className="profilelist-img">
                    <Link to="#" onClick={(e) =>showPopUpButton(e, `/profile-details/${searchList._id}`)}>

                    <img src={profilePhoto ? `${process.env.REACT_APP_BASE_URL_IMAGE}${profilePhoto}` : searchList.gender === 'Male' ? 'assets/img/no-image-male.jpg':'assets/img/no-image-female.jpg'} alt="" width={223} />
                    </Link>
                  </div>
                  )
                    
                  }



                  <div className="profilelist-det">
                    <h2>
                      <Link to="#" onClick={(e) =>showPopUpButton(e, `/profile-details/${searchList._id}`)}>
                       
                       
                       {checkNameShowHide(searchList?.profileSettings?.name_show, planDetailUser) ? searchList.name : nameMask(searchList.name)}{" "} 
                       
                      </Link>&nbsp;
                     
                      <span>
                         <img src="assets/img/icons/verified.png" alt="" />
                      </span>
                    </h2>
                    { /* <h6 className="pinkhd">Profile ID : 600155</h6> */ }
                    <div className="profilelist-detwhite d-md-flex align-items-md-stretch justify-content-md-between">
                      <div>
                        <div className="profiledata-row d-flex align-items-start  mb-2">
                          <span className="fieldname">Age / Height</span>: {(searchList?.dob || searchList?.height)
  ? `${searchList?.dob ? ageCalculate(searchList.dob) : ""}${searchList?.dob && searchList?.height ? ", " : ""}${searchList?.height ? decimalToFeetInches(searchList.height) : ""}`
  : ""}
                          
                        </div>
                        <div className="profiledata-row d-flex align-items-start  mb-2">
                          <span className="fieldname">Religion</span>: {searchList.religion?.name}
                        </div>
                        <div className="profiledata-row d-flex align-items-start  mb-2">
                          <span className="fieldname">Occupation</span>: {searchList?.occupation?.name}
                        </div>
                        <div className="profiledata-row d-flex align-items-start  mb-2">
                          <span className="fieldname">Location</span>: {[searchList?.loc_state?.name, searchList?.loc_city?.name].filter(Boolean).join(", ")}
                        </div>
                        <div className="profiledata-row d-flex align-items-start  mb-2">
                          <span className="fieldname">Education</span>: {searchList.highest_degree?.name}
                        </div>
                        <div className="profiledata-row d-flex align-items-start  mb-2">
                          <span className="fieldname">Manglik Status</span>: {searchList.manglik}
                        </div>
                      </div>
                      <div>
                        
                        
                        <div className="profilelist-pinkbox">
                        
                            {searchList?.shortlist_sent ? 
                           (
                            <button  className="button shortlist-btn shortlisted mb-2" onClick={() => removeShortlistButton(searchList._id, index)}>
                              {" "}
                              <i className="fa-solid fa-star" /> Shortlisted
                            </button>
                            )
                           
                          :
                            ( <button  className="button shortlist-btn mb-2"
                            disabled={searchList.gender === selfUserDetail?.gender ? true : false}
                              onClick={() => shortlistButton(searchList._id, index)}>
                              {" "}
                              <i className="fa-solid fa-star" /> Shortlist
                            </button>
                           )
                            
                          }

                            
                            
                            {showInterest ?
                            
                            <>
                            {searchList?.interest_sent ? (
                                
                                
                                searchList?.interest_sent_status === 'Accepted' ?
                                <span>
                                 
                                 
                                 {(planDetailUser?.plan_id?.name === 'VIP')? null:
                                 <p class="upgradepara text-center">
                                 
                                  <Link to="/membership-plan">Upgrade</Link> to Contact her directly</p>

                                 }
                                    <Link
                                    to={callNumbers[searchList._id] ? `tel:${callNumbers[searchList._id]}` : "#"}
                                    className={`button callnow-btn mb-2 ${
                                      loadingId === searchList._id ? "disabled" : ""
                                    }`}
                                    onClick={(e) => handleCallNoView(e, searchList)}
                                  >
                                    <i className="fa-solid fa-phone"></i>{" "}
                                    {loadingId === searchList._id
                                      ? "Please wait..."
                                      : callNumbers[searchList._id]
                                      ? callNumbers[searchList._id] // ✅ only this row
                                      : "Call Now"}
                                  </Link>


                                    <Link to="#" class="button callnow-btn" onClick={(e) => handleChatClick(e, searchList)}><i class="fa-regular fa-comment"></i> Chat Now</Link>
                                </span>
                                :
                                <span>
                                  {searchList?.interest_sent_status === 'Declined' ?
                                    
                                     <button
                                  className="button expressint-btn mb-2"
                                   
                                >
                                  Declined
                                </button>
                                    :
                                        searchList?.interest_sent_status === 'Pending' ?
                                        <button className="button expressint-btn mb-2">
                                          Interest Already Sent</button>
                                          :null

                                    }
                                </span>


                              ) : (
                                <>
                                <button
                                  className="button expressint-btn mb-2"
                                   onClick={() => sendInterest(searchList._id, index)}
                                   disabled={searchList.gender === selfUserDetail?.gender ? true : false}
                                >
                                  Express Interest
                                </button>

                                
                                </>
                              )}

                              </>
                              :
                          

                          <Link
                            to="#" 
                            onClick={(e) =>showPopUpButton(e, `/profile-details/${searchList._id}`)}
                            className="button viewpro-btn"
                          >
                            <img src="assets/img/icons/eye.png" alt="" /> View
                            Profile
                          </Link>
                  }
                        </div>
                  

                      </div>
                    </div>
                  </div>
                </div>

                  )


                })
              ):(
                 
                <div className="profilelist-box d-md-flex align-items-md-start justify-content-md-start mb-2">
                  No profile found
                </div>
                
              ) 
            }
    </>
  )
}

export default SearchProfileList
